/**
 * TrendModa — Image & Section Lazy Loader
 */
(function () {
  'use strict';

  var IMAGE_THRESHOLD = 0.01;
  var SECTION_THRESHOLD = 0.08;
  var IMAGE_ROOT_MARGIN = '1200px 0px'; // Mobilde kayırma sırasında erken yükle
  var SKELETON_CLASS = 'tm-skeleton--loading';

  var globalImgObserver = null;

  function loadImage(img) {
    if (img.dataset.loaded) return;

    var src = img.dataset.src;
    var srcset = img.dataset.srcset;
    
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;

    if (img.complete) {
      img.classList.add('tm-lazy--loaded');
      img.classList.remove('tm-lazy');
    } else {
      img.addEventListener('load', function() {
        img.classList.add('tm-lazy--loaded');
        img.classList.remove('tm-lazy');
      }, { once: true });
    }

    img.dataset.loaded = 'true';
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function initImageLazyLoad() {
    var lazyImgs = document.querySelectorAll('img[data-src]:not([data-observed]), img[data-srcset]:not([data-observed]), img.tm-lazy:not([data-observed])');
    if (!lazyImgs.length) return;

    if (!window.IntersectionObserver) {
      lazyImgs.forEach(loadImage);
      return;
    }

    if (!globalImgObserver) {
      globalImgObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadImage(entry.target);
            globalImgObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: IMAGE_ROOT_MARGIN, threshold: IMAGE_THRESHOLD });
    }

    lazyImgs.forEach(function (img) {
      img.setAttribute('data-observed', 'true');
      globalImgObserver.observe(img);
    });
  }

  function initSectionReveal() {
    var sections = document.querySelectorAll('[data-lazy-reveal]');
    if (!sections.length) return;

    if (!window.IntersectionObserver) {
      sections.forEach(function (s) { s.classList.add('tm-reveal--visible'); });
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tm-reveal--visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: SECTION_THRESHOLD });

    sections.forEach(function (s) { revealObserver.observe(s); });
  }

  function init() {
    initImageLazyLoad();
    initSectionReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.tmLazy = { init: init, initImageLazyLoad: initImageLazyLoad };

  // Filtre / ajax sonrası DOM'a yeni görseller eklenince otomatik yakala
  if (window.MutationObserver) {
    var domObserver = new MutationObserver(function (mutations) {
      var hasNewImages = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches('img.tm-lazy') ||
            (node.querySelectorAll && node.querySelectorAll('img.tm-lazy, img[data-src]').length > 0)
          );
        });
      });
      if (hasNewImages) initImageLazyLoad();
    });
    domObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
